import React from "react";
import "./radioButtonWithText.scss";
import FocusableDiv from "../../FocusableDiv";

const RadioButtonWithText = (props) => {
  const {
    data,
    text,
    value,
    disabled,
    selected,
    allowClickOnLabel,
    handleChange,
  } = props;

  const handleClick = (data) => {
    if (allowClickOnLabel) {
      handleChange(data);
    }
  };

  // Create UI ==>

  const displayRadioButtonWithText = () => {
    return (
      <FocusableDiv
        className="radio-button-with-text-radio-button"
        onEnter={() => handleChange(data)}
      >
        <span className="radio_button_input">
          <input
            className="radio-button"
            type="radio"
            checked={selected ? true : false}
            value={value}
            disabled={disabled}
            onChange={() => handleChange(data)}
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            tabIndex={-1}
          />
        </span>
        <label
          style={props.style ? props.style : {}}
          onClick={() => !disabled && handleClick(data)}
        >
          {text}
        </label>
      </FocusableDiv>
    );
  };

  // <===

  return <>{displayRadioButtonWithText()}</>;
};

export default RadioButtonWithText;
